var map = {
	"./6BF15105-0060-4E58-8CD1-5D6CE092D141.jpeg": 1129,
	"./ANUNCIO.jpg": 9274,
	"./CARTAZ.jpg": 715,
	"./IMG_0881.jpeg": 5519,
	"./MARCA.JPEG": 7130,
	"./guerreiros.jpg": 5443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 795;